export default {
  installment: {
    id: 'checkout_summary_installment',
    defaultMessage: 'Installment fee',
  },
}
